<template>
    <section class="bannerSection justify-content-center d-flex fade-out-element" id="home">
        <div class="banner-container justify-content-center d-flex align-items-center w-70">

            <div class="banner-item flex-col d-flex gap-1">
                <h3 class="source-code-pro-500">hola, soy</h3>
                <h1 class="inter-500 linear-gradient-black-to-green text-2">Rolando Gómez</h1>
                <p class="banner-description source-code-pro-400">Ayudo a las marcas y empresas a destacar su sitio web con diseños
                    atractivos, bien pensadas y a la medida.</p>
            </div>
            <div class="banner-item">
                <figure class="banner-image-container">
                    <img class="banner-image" src="../assets/images/pic1.png" alt="Rolando Gómez">
                    <span>Be your best version</span>
                </figure>
                <ul class="banner-list">
                    <li class="list-item source-code-pro-300">
                        <img src="../assets/icons/compu.svg" class="shadow-rounded">Trabajo presencial / remoto
                    </li>
                    <li class="list-item source-code-pro-300">
                        <img src="../assets/icons/mensaje.svg" class="shadow-rounded">rolandogomez.dev@gmail.com
                    </li>
                    <li class="list-item source-code-pro-300">
                        <img src="../assets/icons/ubicacion.svg" class="shadow-rounded ">Ciudad de México
                    </li>
                    <li id="skills" class="list-item source-code-pro-500 linear-gradient-black-to-green text-1">
                        Frontend developer
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script setup>

</script>

<style lang="css" scoped>
.bannerSection {
    background-color: #FBF9F5;
    height: auto;
    font-size: 10px;
    padding-bottom: 4em;
}

.banner-container {
    padding: 1em;
    padding-top: 6em;
    height: 100%;
    flex-direction: column;
    width: 100%;
    gap: 0.8em;
}


.banner-item{
    display: flex;
    width: max-content;
    height: max-content;
    font-size: 1.5em;
    position: relative;
}

.banner-item:nth-child(1){
    width: 90%;
    padding: 2em 0;
}

.banner-item:nth-child(2){
    width: 100%;
    flex-direction: column;

}

.flex-col{
    flex-direction: column;
}

p{
    text-align: justify;
    width: 100%;
}



.banner-image-container{
    width: 90%;
    margin: auto;
    max-width: 25em;
    box-shadow: 3px 3px 11px rgb(213, 207, 207);
    border-radius: 0.5em;
    overflow: hidden;
}
.banner-image{
    width: 100%;
    height: 100%;
}

.banner-list{
    list-style: none;
    
    display: flex;
    gap: 1em;
    position: absolute;
    flex-direction: column;
    right: 11%;
    width: 2.7em;

    padding-top: 2em;
}

.list-item{
    display:flex;
    align-items:center;
    width: 2.7em;
    overflow: hidden;
    transition: all 1000ms ease;
}
.list-item:hover{
    transform: translatex(-60vw);
    background-color: #fbf9f58d;
    padding-right: 0.2em;
    border-radius: 1em;
    width: max-content;
    overflow: visible;
}

.list-item:last-child{
    position: absolute;
    left: -67vw;
    top: 50vh;
    width: min-content;
    transform: translateX(0);
}   
.linear-gradient-black-to-green:last-child{
    color: #ffffff;
}
.list-item > img{
    width:2.7em;
}


figure{
    position: relative;
    transition: all 0.3s ease;
}
figure > span{
    position: absolute;
    color: rgb(255, 255, 255);
    background-color: var(--secondary-bg-color);
    padding: 0.3em;
    border-radius: 0.2em;
    font-size: 0.8em;
    width: max-content;
    transform: translateX(-50%);
    opacity: 0;
    transition: all 0.3s ease;
}
figure > span:nth-child(2){
    top: 1em;
    left: 26%;
}
img:hover + span{
    opacity: 1;
}
figure:hover{
    transform: scale(1.05);
}

@media (min-width: 576px) {
  .bannerSection {
    padding-top: 60px;
    height: 600px;
  }
  .banner-container {
    padding: 2em;
    flex-direction: row;
    width: 70%;
  }
  .banner-item{
    height: 80%;
  }
  .banner-item:nth-child(1){
    max-width: 22em;
    padding: 1em;
    width: 40%;
    height: max-content;

   }
  .banner-item:nth-child(2){
        width: 70%;
        max-width: 40em;
        padding: 0.8em;
        flex-direction: row;
   }
    p{
        width: 13.3em;
    }

    .banner-image-container{
        width: 60%;
        padding: 0.5em;
    }
    .banner-image{
        border-radius: 0.5em;
    }
    .banner-list{
        flex-direction: column;
        position: static;
        width: max-content;
        padding: 0.7em;
        gap: 2em;
    }
    .list-item{
        width: auto;
    }
    .list-item:last-child{
        position: static;

    }
    .list-item:hover{
        transform: translateX(0);
        background-color: #fbf9f500;
        padding-right: 0;
        border-radius: 0;
        width: auto;
    }
    .linear-gradient-black-to-green{
    color: transparent;
}
}
</style>